import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39eb5a61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Angajat", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col col-10_Item" }
const _hoisted_6 = { class: "col col-40_Item" }
const _hoisted_7 = { class: "col col-50_Item" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Tip cerere", -1))
const _hoisted_10 = {
  key: 1,
  class: "row"
}
const _hoisted_11 = {
  key: 2,
  class: "row"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Tip concediu", -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Prima zi de concediu", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Ultima zi de concediu", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_19 = { class: "col-8" }
const _hoisted_20 = {
  key: 1,
  class: "text__label--thin"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Observatie", -1))
const _hoisted_23 = {
  key: 3,
  class: "row"
}
const _hoisted_24 = { style: {"display":"flex","justify-content":"flex-start","flex-direction":"column","width":"100%"} }
const _hoisted_25 = { style: {"display":"flex","flex-direction":"row","align-items":"center","justify-content":"flex-start"} }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--medium",
  style: {"font-weight":"400"}
}, "Documente", -1))
const _hoisted_28 = { class: "text__label--thin" }
const _hoisted_29 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_33 = { class: "mobile-only" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_36 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}
const _hoisted_37 = {
  key: 1,
  id: "iframe_preview_scan",
  type: "application/pdf",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none"}
}
const _hoisted_38 = {
  key: 2,
  id: "iframe_preview_scan",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none","display":"block"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "q-ml-sm" }, "Doriti sa salvati cererea?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_form, { ref: "myForm" }, {
      default: _withCtx(() => [
        ((_ctx.is_all == 1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_q_select, {
                readonly: (_ctx.timeRequest.appid != 0),
                name: "select-type",
                outlined: "",
                "use-input": "",
                "input-debounce": "300",
                onFilter: _ctx.filterPersoane,
                class: "col-8",
                modelValue: _ctx.timeRequest.marca,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeRequest.marca) = $event)),
                options: _ctx.optionsPersoane,
                "option-value": "marca",
                "option-label": (vl) => ((vl.marca != 0 && vl != 0) ? vl.nume_prenume : ''),
                rules: [(val) => (val && val != 0) || 'Alegeti persoana'],
                "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                "emit-value": "",
                "map-options": "",
                "lazy-rules": "",
                dense: "",
                style: {"max-height":"12vh"}
              }, {
                "no-option": _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "text-grey" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" No results ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                option: _withCtx(({ itemProps, opt }) => [
                  _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(itemProps)), {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(opt.marca), 1),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(opt.nume_prenume), 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(opt.organization_unit_descriere), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["readonly", "onFilter", "modelValue", "options", "option-label", "rules"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_q_select, {
            class: "col-8",
            outlined: "",
            modelValue: _ctx.selectedNomConcediiParent,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedNomConcediiParent) = $event)),
              _ctx.onValueChangeTimeRequestParent
            ],
            options: _ctx.optionsTimeRequestParent,
            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'max-height: 12vh; width: 100%' : 'max-height: 12vh;'),
            "option-value": "appid",
            "option-label": "tip_concediu",
            "emit-value": "",
            "map-options": "",
            "lazy-rules": "",
            dense: "",
            "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
            rules: [ val => val && val > 0 || 'Alegeti tipul de cerere!']
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "style", "rules"])
        ]),
        (_ctx.isVisibleFlagPlanAnualRegular)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$q.platform.is.mobile ? '' : 'col-4 form__label')
              }, null, 2),
              _createVNode(_component_q_toggle, {
                class: "col-8",
                outlined: "",
                modelValue: _ctx.stareFlagPlanAnualRegular,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stareFlagPlanAnualRegular) = $event)),
                  _ctx.onValueChangeTimeRequestStatusPlanRegularOrAnual
                ],
                "checked-icon": "lock",
                color: "blue",
                label: "Regular/Anual",
                "unchecked-icon": "lock_open",
                "emit-value": "",
                "map-options": "",
                "lazy-rules": "",
                dense: "",
                style: {"padding-bottom":"20px"},
                disable: !_ctx.isAllowedPlanAnual
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isVisibleNomConcediiChild)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_q_select, {
                class: "col-8",
                outlined: "",
                modelValue: _ctx.selectedNomConcediiChild,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedNomConcediiChild) = $event)),
                options: _ctx.optionsTimeRequestChild,
                style: _normalizeStyle(!_ctx.isVisibleNomConcediiChild ? (_ctx.$q.platform.is.mobile ? 'max-height: 12vh;padding-bottom:20px; width: 100%;' : 'max-height: 12vh;padding-bottom:20px;') :  (_ctx.$q.platform.is.mobile ? 'max-height: 12vh; width:100%' : 'max-height: 12vh;')),
                "option-value": "appid",
                "option-label": "tip_concediu",
                "emit-value": "",
                "map-options": "",
                "lazy-rules": "",
                dense: "",
                "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                rules: _ctx.isVisibleNomConcediiChild ? [ val => val && val > 0 || 'Alegeti tipul de concediu!'] : undefined
              }, null, 8, ["modelValue", "options", "style", "rules"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_q_input, {
            class: "col-8",
            outlined: "",
            modelValue: _ctx.timeRequest.start_date,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.timeRequest.start_date) = $event)),
            dense: "",
            mask: "##.##.####",
            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%; max-height: 12vh;;' : 'width: 200px; max-height: 12vh;;'),
            "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
            rules: [
            (val) => (val && val.length > 0) || 'Completati prima zi de concediu',
          ]
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_popup_proxy, {
                ref: "qDateProxy1",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_date, {
                    minimal: "",
                    modelValue: _ctx.timeRequest.start_date,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.timeRequest.start_date) = $event)),
                      _ctx.onChangeStartDate
                    ],
                    mask: "DD.MM.YYYY",
                    locale: _ctx.myLocale
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "locale"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 8, ["modelValue", "style", "rules"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_q_input, {
            class: "col-8",
            outlined: "",
            modelValue: _ctx.timeRequest.end_date,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.timeRequest.end_date) = $event)),
            dense: "",
            mask: "##.##.####",
            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%; max-height: 12vh;;' : 'width: 200px; max-height: 12vh;;'),
            "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
            rules: [
            (val) => (val && val.length > 0) || 'Completati ultima zi de concediu!',
          ]
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_popup_proxy, {
                ref: "qDateProxy2",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_date, {
                    minimal: "",
                    modelValue: _ctx.timeRequest.end_date,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.timeRequest.end_date) = $event)),
                      _ctx.onChangeEndDate
                    ],
                    mask: "DD.MM.YYYY",
                    locale: _ctx.myLocale
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "locale"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 8, ["modelValue", "style", "rules"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            (_ctx.seCalculeazaNrZileLucratoare)
              ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                  key: 0,
                  indeterminate: "",
                  color: "warning",
                  class: "q-mt-sm"
                }))
              : _createCommentVNode("", true),
            (_ctx.SePoateAfisaNrZileLucratoare)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.timeRequest.nr_working_days) + " zile lucratoare", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_q_input, {
            class: "col-8",
            outlined: "",
            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'max-height: 12vh; width: 100%' : 'max-height: 12vh;'),
            modelValue: _ctx.timeRequest.observatie,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.timeRequest.observatie) = $event)),
            type: "textarea",
            ref: "refDescriere",
            "lazy-rules": "",
            counter: "",
            maxlength: "200",
            rows: "3",
            dense: "",
            "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
            rules: !_ctx.stareFlagPlanAnualRegular ? [ val => val && val.length > 0 || 'Completati observatia!'] : []
          }, null, 8, ["style", "modelValue", "rules"])
        ]),
        (_ctx.timeRequest.appid != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.user.auth_for_upload_scan == 'y')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          color: "primary",
                          icon: "add_box",
                          "no-caps": "",
                          onClick: _ctx.openFormUploadFile
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, {
                              "transition-show": "rotate",
                              "transition-hide": "rotate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Incarca document nou ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_27
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_28, "Puteti atasa documente relative la aceasta cerere.", 512), [
                  [_vShow, _ctx.scans.length==0]
                ]),
                (_ctx.uploadingFileToServer)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 0,
                      color: "primary",
                      size: "3em",
                      thickness: 10
                    }))
                  : (_openBlock(), _createElementBlock("table", _hoisted_29, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scans, (scan) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: scan.appid
                          }, [
                            (_ctx.timeRequest.stare === 'initiat')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                  _createElementVNode("span", {
                                    class: "material-icons cursor-pointer",
                                    style: {"color":"red","font-size":"1.3rem"},
                                    onClick: ($event: any) => (_ctx.askIfRemoveScan(scan))
                                  }, "delete_forever", 8, _hoisted_31)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_32, _toDisplayString(scan.description), 1),
                              _createElementVNode("div", _hoisted_33, _toDisplayString(scan.description), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_q_btn, {
                                round: "",
                                color: "black",
                                icon: "cloud_download",
                                size: "xs"
                              }),
                              _createVNode(_component_q_menu, {
                                fit: "",
                                "transition-show": "scale",
                                "transition-hide": "scale"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DialogOpenScan, {
                                    appid: scan.appid,
                                    type_scan: "TimeRequest"
                                  }, null, 8, ["appid"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _hoisted_34,
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'column absolute-bottom-center q-pa-sm q-gutter-sm' : 'absolute-bottom-right q-pa-sm')
    }, [
      (_ctx.timeRequest.appid != 0)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            label: "Vizualizeaza cererea",
            color: "brown-5",
            icon: "file_copy",
            onClick: _ctx.onPreviewCerere,
            style: {"margin-right":"5px"},
            size: "sm"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        size: "sm",
        label: "Salveaza",
        type: "submit",
        color: "primary",
        disable: _ctx.loadingData || !_ctx.requestIsFilled,
        onClick: _ctx.onSave
      }, null, 8, ["disable", "onClick"]),
      (_ctx.timeRequest.appid != 0 && _ctx.timeRequest.stare === 'initiat' && !_ctx.stareFlagPlanAnualRegular)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            label: "TRIMITE PE FLUX",
            color: "green",
            onClick: _ctx.onSendApproved,
            style: {"margin-left":"5px"},
            size: "sm"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        label: "Renunt",
        type: "reset",
        flat: "",
        onClick: _ctx.onCancel,
        style: {"margin-left":"5px"},
        size: "sm"
      }, null, 8, ["onClick"])
    ], 2),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUploadFile,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_linear_progress, {
              value: 0.6,
              color: "pink"
            }),
            _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
              default: _withCtx(() => [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_q_input, {
                    counter: "",
                    outlined: "",
                    modelValue: _ctx.uploadScanTitle,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                    label: "Titlu document (minim 4 caractere)",
                    dense: "",
                    maxlength: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "file",
                  name: "fileToUpload",
                  id: "fileToUpload",
                  ref: "myFileToUpload",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.prepareForUpload($event))),
                  style: {"margin-bottom":"10px"}
                }, null, 544), [
                  [_vShow, _ctx.uploadScanTitle.length > 3]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  disable: !(_ctx.uploadScanTitle.length>3),
                  icon: "cloud_upload",
                  color: "white",
                  "text-color": "black",
                  label: "Salveaza pe server",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.uploadFile())),
                  loading: _ctx.uploadingFileToServer,
                  style: {"margin-bottom":"5px"}
                }, null, 8, ["disable", "loading"]), [
                  [_vShow, _ctx.checkIfFileIsSelected]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showPreviewFile,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showPreviewFile) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": "slide-up",
      "transition-hide": "slide-down"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createElementVNode("h5", null, _toDisplayString(_ctx.titleForPreviewForm), 1),
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "rotate",
                      "transition-hide": "rotate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.downloadingFile)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      query: "",
                      "track-color": "orange",
                      color: "purple",
                      class: "q-mt-sm"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isPDFFileType)
                  ? (_openBlock(), _createElementBlock("iframe", _hoisted_37))
                  : (_openBlock(), _createElementBlock("img", _hoisted_38))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.confirmVizualizareCererea,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.confirmVizualizareCererea) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_avatar, {
                  icon: "file_copy",
                  color: "primary",
                  "text-color": "white"
                }),
                _hoisted_39
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  size: "sm",
                  label: "Da",
                  color: "primary",
                  onClick: _ctx.onSaveCerere
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  size: "sm",
                  flat: "",
                  label: "Nu",
                  onClick: _ctx.onCancelPreview
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}